import { create } from 'zustand';

import { IColorbar } from '../models/interfaces/IColorbar';
import { SeismicAttribute } from '../models/interfaces/ISurveyMetadata';
import { IAbsoluteGain } from './useSeismicStore';

export interface IAttributesStore {
    swipeOpacity: number,
    overlayOpacity: number,
    setSwipeOpacity: (value: number) => void,
    setOverlayOpacity: (value: number) => void,
    swipeGain: IAbsoluteGain,
    overlayGain: IAbsoluteGain,
    setSwipeGain: (value: IAbsoluteGain) => void,
    setOverlayGain: (value: IAbsoluteGain) => void,
    swipeColorbar: IColorbar,
    overlayColorbar: IColorbar,
    setSwipeColorbar: (value: IColorbar) => void,
    setOverlayColorbar: (value: IColorbar) => void,
    selectedProductName: string,
    setSelectedProductName: (val: string) => void,
    overlaySelectedProductName: string,
    setOverlaySelectedProductName: (val: string) => void,
    swipeSelectedProductName: string,
    setSwipeSelectedProductName: (val: string) => void,
    availableProducts: SeismicAttribute[],
    setAvailableProducts: (val: SeismicAttribute[]) => void,
    selectedLineName: string|null,
    setSelectedLineName: (val: string|null) => void,
}

export const UseAttributesStore = create<IAttributesStore>()(
    (set, get) => ({
        swipeOpacity: 1,
        overlayOpacity: 1,
        setSwipeOpacity: (value) => set({ swipeOpacity: value }),
        setOverlayOpacity: (value) => set({ overlayOpacity: value }),
        swipeGain: { min: 0, max: 0 },
        overlayGain: { min: 0, max: 0 },
        setSwipeGain: (value) => set({ swipeGain: value }),
        setOverlayGain: (value) => set({ overlayGain: value }),
        swipeColorbar: {
            Background: '#fff',
            Label: '',
            Name: '',
            Picture: '',
            Token: ''
        },
        overlayColorbar: {
            Background: '#fff',
            Label: '',
            Name: '',
            Picture: '',
            Token: ''
        },
        setSwipeColorbar: (value) => set({ swipeColorbar: value }),
        setOverlayColorbar: (value) => set({ overlayColorbar: value }),
        selectedProductName: '',
        setSelectedProductName: (val) => set({ selectedProductName: val }),
        overlaySelectedProductName: '',
        setOverlaySelectedProductName: (val) => set({ overlaySelectedProductName: val }),
        swipeSelectedProductName: '',
        setSwipeSelectedProductName: (val) => set({ swipeSelectedProductName: val }),
        availableProducts: [],
        setAvailableProducts: val => set({ availableProducts: val }),
        selectedLineName: null,
        setSelectedLineName: val => set({ selectedLineName: val }),
    })
);